import React from 'react';

const HiddenInput = ({ field }) => {
  const value = field.value || '';

  return (
    <input
      {...field}
      value={value}
      data-testid={`hidden-input-${field.name}`}
      type="hidden"
      id={field.name}
      disabled
    />
  );
};

export default HiddenInput;
